import type { FlexProps } from '@chakra-ui/react';
import { Flex, Box } from '@chakra-ui/react';

export interface EmptyLayoutProps extends FlexProps {
  iconSize?: FlexProps['w'];
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

export const EmptyLayout = memo(function EmptyLayout({
  children,
  icon,
  iconSize = '25',
  ...props
}: EmptyLayoutProps) {
  return (
    <Flex p="12" flexDir="column" align="center" justify="center" gap="2" {...props}>
      {icon && (
        <Box width={iconSize} height={iconSize}>
          {icon}
        </Box>
      )}
      {children && (
        <Box fontSize="sm" textAlign="center">
          {children}
        </Box>
      )}
    </Flex>
  );
});
